import '../../assets/fontawesome/css/all.min.css';
import Copyright from '../Copyright/Copyright';
import SocialMediaLinks from '../SocialMediaLinks/SocialMediaLinks';
import './Footer.css';

const Footer = () => {

  return (
    <footer className="Footer text-center py-8">
      <span className="display-font block text-4xl p-4">LAURI MIKAEL</span>

      <SocialMediaLinks />
      
      <div className="my-8">
        <b>Yhteydenotot: </b><a href="mailto:laurimikael.musiikki@gmail.com">laurimikael.musiikki@gmail.com</a>
      </div>
      <div className="py-4">
        <Copyright />
      </div>
    </footer>
  );
}

export default Footer